import Route from '@ember/routing/route';

export default class LigaRoute extends Route {}
